module.exports = __webpack_public_path__ + "static/media/play-resolved.d26e2120.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play-resolved.svg
// module id = ./src/assets/images/play-resolved.svg
// module chunks = 0